import { render, staticRenderFns } from "./OwnClassTeacherDeleteDialog.vue?vue&type=template&id=066a8b1f"
import script from "./OwnClassTeacherDeleteDialog.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports